import { Helmet } from "react-helmet";

import "antd/dist/antd.min.css";

import { StatusProvider } from "./contexts/StatusContext";
import { ConnectionsStatusProvider } from "./contexts/ConnectionsStatusContext";
import { TimeZoneProvider } from "./contexts/TimeZoneContext";
import { LicenseProvider } from "./contexts/LicenseContext";
import { PermissionProvider } from "./contexts/PermissionContext";
import "./stylesheets/index.scss";
import SystemTypeIndicator from "./components/header/systemTypeIndicator";
import StatusMessage from "./components/header/statusMessage";
import Footer from "./components/footer";
import Routes from "./routes";
import AppBodyHook from "./appBodyHook";
import ConnectionHeaderStatus from "./components/header/connectionHeaderStatus";
import NewVersionStatus from "./components/header/newVersionStatus";
import Sidebar from "./components/generic/components/sideMenu";
import { useAuthState } from "./contexts/authentication";
import Header from "./components/header";
import { NavigationMenuProvider } from "./contexts/NavigationMenuContext";
import { convertStringToBoolean } from "./helpers";
import FrontChat from "./components/generic/components/frontChatWrapper";

/**
 * App Body conatins status, connection status, and timezone providers, connectionTest,
 * StatusMessage, SystemTypeIndicator, Header, Routes, and Footer
 * @returns The main app body
 */
export default function AppBody() {
  const { isAuthenticated } = useAuthState();
  const {
    statusQuery,
    powerpickConnectionQuery,
    timeZone,
    permissionsQuery,
    license,
    versionChanged,
    navigationMenus,
  } = AppBodyHook();

  return (
    <StatusProvider value={{ ...statusQuery.data }}>
      <ConnectionsStatusProvider value={powerpickConnectionQuery.data}>
        <TimeZoneProvider value={timeZone}>
          <LicenseProvider value={license}>
            <NavigationMenuProvider value={navigationMenus}>
              <FrontChat />
              <Helmet>
                <meta charSet="utf-8" />
                <title>ItemPath</title>
              </Helmet>
              {!statusQuery.data.loading &&
                (convertStringToBoolean(navigationMenus) ? (
                  <div className="flex">
                    <Sidebar />
                    <div
                      className={`flex-1 ${
                        isAuthenticated &&
                        !["invalid", "locked", "restarting"].includes(
                          statusQuery.data?.message,
                        ) &&
                        "pl-20"
                      }`}
                    >
                      <NewVersionStatus versionChanged={versionChanged} />
                      <ConnectionHeaderStatus />
                      <StatusMessage />
                      <SystemTypeIndicator />

                      <div className="mt-[20px] px-4">
                        <PermissionProvider
                          value={{
                            isLoading: permissionsQuery.isFetching,
                            ...permissionsQuery.data,
                          }}
                        >
                          <Routes />
                        </PermissionProvider>
                        <Footer />
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <NewVersionStatus versionChanged={versionChanged} />
                    <ConnectionHeaderStatus />
                    <StatusMessage />
                    <SystemTypeIndicator />

                    <div className="itemPath">
                      <Header />
                      <PermissionProvider
                        value={{
                          isLoading: permissionsQuery.isFetching,
                          ...permissionsQuery.data,
                        }}
                      >
                        <Routes />
                      </PermissionProvider>
                      <Footer />
                    </div>
                  </>
                ))}
            </NavigationMenuProvider>
          </LicenseProvider>
        </TimeZoneProvider>
      </ConnectionsStatusProvider>
    </StatusProvider>
  );
}
